import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {FormControl, FormGroup} from '@angular/forms';
import {AuthService} from '../services/auth.service';
import {catchError, Subscription, take, throwError} from 'rxjs';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  public pending: boolean = false;
  private invalidLoginCounter = 0;
  public authForm: FormGroup = new FormGroup({
    email: new FormControl(''),
    password: new FormControl(''),
  });

  constructor(
    private router: Router,
    private http: HttpClient,
    private auth: AuthService
  ) { }

  ngOnInit(): void {
    this.auth.logout();
    this.devAutoLogin();
  }

  /**
   * Local dev auto-login: skips the login form entirely in dev mode.
   * In dev, the API has DEV_AUTH_BYPASS=true so any credentials work —
   * we just need tokens in localStorage for the auth guard.
   */
  private devAutoLogin(): void {
    if (environment.production) return;
    this.pending = true;
    this.authForm.patchValue({ email: 'dev@local', password: 'dev' });
    this.auth.login('dev@local', 'dev')
      .pipe(take(1))
      .subscribe({
        next: () => this.router.navigateByUrl('/grid'),
        error: () => { this.pending = false; }
      });
  }

  public login(): void {
    this.pending = true;
    this.auth.login(this.authForm.get('email')?.value, this.authForm.get('password')?.value)
      .pipe(
        take(1),
        catchError((err: any) => {
        this.invalidLoginCounter++;

        if (this.invalidLoginCounter >= 4) {
          setTimeout(() => { this.pending = false; }, 2000 * this.invalidLoginCounter);
        } else {
          this.pending = false;
        }

        return throwError(err);
      })).subscribe((resp: any) => {
        this.router.navigateByUrl('/grid');
    });
  }
}
